import { SuperbetRouteConfig } from '@superbet-group/web.types';
import { Route } from 'vue-router';

import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';
import { AnalyticsScreenNames } from '@app/utils/analyticsScreenNames';
import { articlePage } from '@pages/ArticlePage';
import { newsPage } from '@pages/NewsPage';

function getMetaTitle(route: Route) {
    return route.params?.articleTitle ?? Title.News.Articles;
}

function getMetaDescription(route: Route) {
    if (route.params?.articleDescription) {
        return route.params.articleDescription.slice(0, 150).concat('...');
    }
}

export const newsRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.News.Article,
        name: RouteName.News.Article,
        isAccessible: Product.News,
        components: {
            ...defaultLayout,
            ...articlePage,
        },
        meta: {
            title: getMetaTitle,
            metaTags: {
                description: getMetaDescription,
            },
            superAnalytics: {
                pageName: AnalyticsScreenNames.newsArticleDetails,
            },
        },
    },
    {
        path: Link.News.Feed,
        name: RouteName.News.Feed,
        isAccessible: Product.News,
        components: {
            ...defaultLayout,
            ...newsPage,
        },
        meta: {
            title: Title.News.Feed,
            superAnalytics: {
                pageName: AnalyticsScreenNames.news,
            },
            headerTitle: 'headerTitle.news',
        },
    },
];
